import React, { useState } from 'react';
import { Mail, MessageCircle, MapPin } from 'lucide-react';
import { useTranslation } from '../hooks/useTranslation';

export default function Contact() {
  const { t } = useTranslation();
  const [form, setForm] = useState({ name: '', email: '', subject: '', message: '' });
  const [sent, setSent] = useState(false);

  const handleSubmit = (e) => {
    e.preventDefault();
    setSent(true);
    setForm({ name: '', email: '', subject: '', message: '' });
    setTimeout(() => setSent(false), 3500);
  };

  const CARDS = [
    { icon: Mail, t: t('contact.infoEmail'), s: 'mskwatchh@gmail.com' },
    { icon: MessageCircle, t: t('contact.infoResponse'), s: t('contact.infoResponseValue') },
    { icon: MapPin, t: t('contact.infoAtelier'), s: t('contact.infoAtelierValue') }
  ];

  return (
    <main>
      <section className="pt-20 pb-14 lg:pt-28 lg:pb-16 bg-ivory text-center">
        <div className="max-w-3xl mx-auto px-4 animate-fade-up">
          <div className="text-[11px] tracking-luxury uppercase text-gold mb-5">{t('contact.label')}</div>
          <h1 className="font-serif text-5xl md:text-7xl font-light">{t('contact.title')}</h1>
          <p className="mt-6 text-[#666]">{t('contact.subtitle')}</p>
        </div>
      </section>

      <section className="pb-24">
        <div className="max-w-6xl mx-auto px-4 lg:px-8 grid md:grid-cols-3 gap-10 mb-14">
          {CARDS.map((c, i) => (
            <div key={i} className="text-center border border-[#EAE4D8] p-8 hover:border-gold transition-colors duration-500">
              <c.icon className="w-6 h-6 text-gold mx-auto" strokeWidth={1.2} />
              <div className="font-serif text-xl mt-4">{c.t}</div>
              <div className="text-sm text-[#666] mt-2">{c.s}</div>
            </div>
          ))}
        </div>

        <div className="max-w-2xl mx-auto px-4">
          <form onSubmit={handleSubmit} className="space-y-4" data-testid="contact-form">
            <div className="grid md:grid-cols-2 gap-4">
              <div>
                <label className="text-[11px] tracking-luxury uppercase text-[#666] block mb-2">{t('contact.formName')}</label>
                <input required value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })} className="w-full bg-transparent border border-[#EAE4D8] px-4 py-3 focus:outline-none focus:border-gold text-sm" data-testid="contact-input-name" />
              </div>
              <div>
                <label className="text-[11px] tracking-luxury uppercase text-[#666] block mb-2">{t('contact.formEmail')}</label>
                <input required type="email" value={form.email} onChange={(e) => setForm({ ...form, email: e.target.value })} className="w-full bg-transparent border border-[#EAE4D8] px-4 py-3 focus:outline-none focus:border-gold text-sm" data-testid="contact-input-email" />
              </div>
            </div>
            <div>
              <label className="text-[11px] tracking-luxury uppercase text-[#666] block mb-2">{t('contact.formSubject')}</label>
              <input required value={form.subject} onChange={(e) => setForm({ ...form, subject: e.target.value })} className="w-full bg-transparent border border-[#EAE4D8] px-4 py-3 focus:outline-none focus:border-gold text-sm" data-testid="contact-input-subject" />
            </div>
            <div>
              <label className="text-[11px] tracking-luxury uppercase text-[#666] block mb-2">{t('contact.formMessage')}</label>
              <textarea required rows={5} value={form.message} onChange={(e) => setForm({ ...form, message: e.target.value })} className="w-full bg-transparent border border-[#EAE4D8] px-4 py-3 focus:outline-none focus:border-gold text-sm resize-none" data-testid="contact-input-message" />
            </div>
            <button type="submit" className="w-full bg-[#1A1A1A] text-white px-8 py-4 text-[11px] tracking-luxury uppercase hover:bg-gold transition-colors duration-500" data-testid="contact-submit-button">
              {sent ? t('contact.formSent') : t('contact.formSend')}
            </button>
          </form>
        </div>
      </section>
    </main>
  );
}
